import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { Row } from '../view.box';
import { DashboardPeriodDates, DashboardPeriodGroup } from './dashboard.period';

export const DashboardHeader: FC = observer(() => {
	return (
		<Row justifyContent="space-between">
			<DashboardPeriodGroup periods={[1, 7, 30]} />
			<DashboardPeriodDates />
		</Row>
	);
});
